export const stopPropagation = (event: React.MouseEvent) => {
  event.stopPropagation();
};
